const DashboardSVG = ({fill, stroke}) => {
  return (
<svg
  width="20"
  height="20"
  viewBox="0 0 30 30"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g
    id="action-dashboard-speed-monitor-activity-icon 1"
    clip-path="url(#clip0_3907_9283)"
  >
    <g id="Group">
      <path
        id="Vector"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9275 17.0739C11.782 15.9284 11.782 14.0711 12.9275 12.9256C14.0731 11.78 15.9303 11.78 17.0759 12.9256C18.2214 14.0711 18.2214 15.9284 17.0759 17.0739C15.9303 18.2195 14.0731 18.2195 12.9275 17.0739Z"
        stroke={stroke}
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M27.8403 11.923C28.076 12.9102 28.2008 13.9404 28.2008 14.9998C28.2008 22.29 22.2909 28.1998 15.0008 28.1998C7.71062 28.1998 1.80078 22.29 1.80078 14.9998C1.80078 7.70965 7.71062 1.7998 15.0008 1.7998C16.3053 1.7998 17.5656 1.98904 18.7558 2.34155"
        stroke={stroke}
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M17.9336 12.0667L25.2669 4.7334"
        stroke={stroke}
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </g>
  <defs>
    <clipPath id="clip0_3907_9283">
      <rect
        width="29.3333"
        height="29.3333"
        fill={fill}
        transform="translate(0.333984 0.333008)"
      />
    </clipPath>
  </defs>
</svg>
)
}

export default DashboardSVG;